var Geometries = (function(){

    function Geometries(){
        THREE.Object3D.call(this);

        var geometry = new THREE.BoxGeometry(100, 100, 100);
        var material = new THREE.MeshBasicMaterial({color: 0x3facc8, wireframe: true, transparent: true});
        this.box = new THREE.Mesh(geometry, material);
        this.add(this.box);
        this.box.position.set(0, 0, 200);

        geometry = new THREE.SphereGeometry(70);
        material = new THREE.MeshBasicMaterial({color: 0xeb4357, wireframe: true, transparent: true});
        this.sphere = new THREE.Mesh(geometry, material);
        this.add(this.sphere);

        var loader = new THREE.JSONLoader();
        loader.load('assets/models/Suzanne.js', this.onSuzanneLoaded.bind(this));

        this.tl = new TimelineMax();
        this.tl.fromTo(this.box.material, 1, {opacity: 0}, {opacity: 0.45}, 0);
        this.tl.fromTo(this.box.position, 1, {y: -200}, {y: 0, ease: Expo.easeOut}, 0);
        this.tl.fromTo(this.sphere.material, 1, {opacity: 0}, {opacity: 0.45}, 0.1);
        this.tl.fromTo(this.sphere.position, 1, {y: -200}, {y: 0, ease: Expo.easeOut}, 0.1);
    }

    Geometries.prototype = new THREE.Object3D;
    Geometries.prototype.constructor = Geometries;

    Geometries.prototype.onSuzanneLoaded = function(geometry) {
        var material = new THREE.MeshBasicMaterial({color: 0xebaa43, wireframe: true, transparent: true});
        this.model = new THREE.Mesh(geometry, material);
        this.add(this.model);
        this.model.scale.multiplyScalar(70);
        this.model.rotation.z = -Math.PI * 0.5;
        this.model.rotation.x = Math.PI * 0.5;
        this.model.position.set(0, 0, -200);
        this.tl.fromTo(this.model.material, 1, {opacity: 0}, {opacity: 0.45}, 0.2);
        this.tl.fromTo(this.model.position, 1, {y: -200}, {y: 0, ease: Expo.easeOut}, 0.2);
    };

    Geometries.prototype.update = function() {
        this.box.rotation.x += 0.01;
        this.box.rotation.y += 0.01;
        this.sphere.rotation.x += 0.01;

        if(!this.model) return;

        this.model.rotation.x -= 0.01;
        this.model.rotation.y -= 0.01;
    };

    return Geometries;
})();